import { CommonTestAttributes } from 'chaika-test-attributes';

import style from './TimeSelect.module.scss';

import { Select, OptionType } from '@components/Select';

import { TimeData } from '../types';
import { makeHourOptions, makeMinutesOptions } from './utils/timeSelectOptions';

export interface TimeSelectProps {
    title?: string;
    time: TimeData;
    name?: string;
    minTime?: TimeData;
    maxTime?: TimeData;
    hourOptions?: OptionType<number>[];
    minutesOptions?: OptionType<number>[];
    onSelect(time: TimeData, name?: string): void;
}

export function TimeSelect({
    title,
    time,
    name,
    minTime,
    maxTime,
    hourOptions,
    minutesOptions,
    onSelect,
}: TimeSelectProps) {
    const { hour, minutes } = time;

    const handleSelect = ({ value }: OptionType<number>, selectName: string): void => {
        onSelect({ ...time, [selectName]: value }, name);
    };

    return (
        <div className={style.root}>
            {title && <div className={style.title}>{title}</div>}
            <div className={style.selects}>
                <div className={style.selectWrapper}>
                    <Select
                        dataTest={CommonTestAttributes.TimeSelectHour}
                        name={'hour'}
                        selectedValue={hour}
                        options={makeHourOptions(hourOptions, minTime, maxTime)}
                        onChange={handleSelect}
                    />
                </div>
                <span className={style.separator}>:</span>
                <div className={style.selectWrapper}>
                    <Select
                        dataTest={CommonTestAttributes.TimeSelectMinutes}
                        name={'minutes'}
                        selectedValue={minutes}
                        options={makeMinutesOptions(time, minutesOptions, minTime, maxTime)}
                        onChange={handleSelect}
                    />
                </div>
            </div>
        </div>
    );
}
